// FAVOR APPLE PAY in the single express-button slot.
// The cart's wallet stack is ordered Shop Pay, Apple Pay, … and we clip it to a
// single button (see theme.css). On a device that actually supports Apple Pay
// (iPhone/Mac Safari) we flag the document so CSS can shift the stack up one
// slot, showing Apple Pay instead of Shop Pay. On non-Apple devices we leave the
// first button (Shop Pay) showing so they still get a valid express button.
(function flagApplePay() {
  try {
    if (window.ApplePaySession && typeof ApplePaySession.canMakePayments === 'function' && ApplePaySession.canMakePayments()) {
      document.documentElement.classList.add('apple-pay-available');
    }
  } catch (_) { /* not available */ }
})();

// CART DRAWER
const drawer = document.querySelector('[data-cart-drawer]');
const menuDrawer = document.querySelector('[data-menu-drawer]');

function openDrawer(el) {
  el?.classList.add('is-open');
  el?.setAttribute('aria-hidden', 'false');
  if (el === drawer) {
    document.body.classList.add('cart-open');
    // Re-sync the express checkout button (Apple Pay / Shop Pay) every time the
    // cart opens. The accelerated-checkout web component only renders its buttons
    // once it's initialised WHILE VISIBLE; if the cart was empty (block hidden)
    // at page load — which is the usual case on the homepage / shop-all — the
    // component never upgraded, so the button appeared to exist only on the
    // product page. Unhiding + re-initialising on open makes it show everywhere.
    const countEl = document.querySelector('[data-cart-count]');
    const count = countEl ? (parseInt(countEl.textContent, 10) || 0) : 1;
    if (typeof syncWalletButtons === 'function') syncWalletButtons(count);
  }
}
function closeDrawer(el) {
  el?.classList.remove('is-open');
  el?.setAttribute('aria-hidden', 'true');
  if (el === drawer) document.body.classList.remove('cart-open');
}

document.addEventListener('click', (e) => {
  if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); openDrawer(drawer); closeDrawer(menuDrawer); }
  if (e.target.closest('[data-cart-close]')) { closeDrawer(drawer); }
  if (e.target.closest('[data-menu-toggle]')) { e.preventDefault(); openDrawer(menuDrawer); closeDrawer(drawer); }
  if (e.target.closest('[data-menu-close]')) { closeDrawer(menuDrawer); }
});

// Single global Escape handler — closes whatever's open.
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  closeDrawer(drawer);
  closeDrawer(menuDrawer);
  document.querySelectorAll('[data-locale-menu]').forEach(m => m.hidden = true);
  if (typeof closeNotify === 'function') closeNotify();
  if (typeof closeSizing === 'function') closeSizing();
});

// LOCALE / CURRENCY PICKER
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-locale-toggle]');
  const insideMenu = e.target.closest('[data-locale-menu]');
  document.querySelectorAll('[data-locale-pill]').forEach(pill => {
    const menu = pill.querySelector('[data-locale-menu]');
    const btn = pill.querySelector('[data-locale-toggle]');
    if (!menu || !btn) return;
    if (toggle && pill.contains(toggle)) {
      menu.hidden = !menu.hidden;
      btn.setAttribute('aria-expanded', String(!menu.hidden));
    } else if (!insideMenu) {
      menu.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  });
});

// Refresh cart drawer contents using Shopify's Section Rendering API.
//
// We used to rebuild the cart HTML client-side from /cart.js. That stripped the
// dynamic checkout buttons (Apple Pay / Shop Pay / Google Pay) because their
// HTML is rendered server-side with secure tokens that can't be reconstructed
// in JS — and the "preserve the existing node" trick failed whenever the cart
// went from empty → has items, because the empty-cart branch of the Liquid
// template doesn't render the wallet button block at all. Result: Apple Pay
// only showed up on the *second* page load (when the server rendered the cart
// already-populated).
//
// Fix: fetch the `main-cart` section fresh from the cart page (Section
// Rendering API), pull out its [data-cart-content] block (which is rendered
// via the `cart-drawer-contents` snippet), and swap it into every
// [data-cart-content] container on the page (the drawer always, and the /cart
// page if we're on it). The wallet buttons come with valid server-issued
// tokens against the current cart, so Apple Pay shows up on first add.
//
// (We use main-cart instead of a cart-drawer section because Shopify's Section
// Rendering API doesn't expose sections rendered via `{% section %}` in a
// layout — only sections rendered through templates or section groups.)
async function refreshCart() {
  try {
    // 1) Rebuild line items + totals + checkout button client-side from /cart.js.
    //    This is theme-independent and always reflects the current cart, so the
    //    drawer can never come back empty after an add (the regression we hit
    //    when we relied solely on the Section Rendering API).
    const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
    if (!cartRes.ok) return;
    const cart = await cartRes.json();

    document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count);

    const content = document.querySelector('[data-cart-content]');
    if (!content) return;

    // The wallet buttons (Apple Pay / Shop Pay) live in the persistent shell
    // OUTSIDE [data-cart-content], so they survive this rebuild. Just toggle
    // their visibility with the cart count and nudge Shopify to re-render them
    // against the new cart state.
    syncWalletButtons(cart.item_count);

    if (cart.item_count === 0) {
      content.innerHTML = `<div class="cart-drawer__empty"><p style="text-transform:uppercase; letter-spacing:0.1em; font-size:12px;">your cart is empty</p></div>`;
      return;
    }

    const lines = cart.items.map((item, i) => `
      <div class="cart-line" data-line="${i + 1}">
        <a href="${item.url}" class="cart-line__img"><img src="${item.image}" alt=""></a>
        <div>
          <div class="cart-line__head">
            <a href="${item.url}" class="cart-line__title">${(item.product_title || '').toLowerCase()}</a>
            <span class="cart-line__price">${formatMoney(item.final_line_price)}</span>
          </div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-line__variant">${item.variant_title.toLowerCase()}</div>` : ''}
          <div class="cart-line__bottom">
            <div class="qty">
              <button type="button" data-qty-down="${i + 1}">−</button>
              <span>qty ${item.quantity}</span>
              <button type="button" data-qty-up="${i + 1}">+</button>
            </div>
            <button type="button" class="cart-line__remove" data-remove="${i + 1}">delete</button>
          </div>
        </div>
      </div>
    `).join('');
    content.innerHTML = `
      <div class="cart-drawer__items" data-cart-items>${lines}</div>
      <div class="cart-drawer__totals">
        <div class="cart-drawer__totals-row cart-drawer__totals-row--muted"><span>shipping</span><span>calculated at checkout</span></div>
        <div class="cart-drawer__totals-row"><span>subtotal</span><span>${formatMoney(cart.total_price)}</span></div>
      </div>
      <form action="/cart" method="post"><button type="submit" name="checkout" class="cart-drawer__checkout"><span>checkout</span></button></form>
    `;
  } catch (e) { console.error(e); }
}

// Show/hide the persistent wallet-button block (in the drawer shell, outside
// [data-cart-content]) based on cart count, and ask Shopify to (re)initialise
// the accelerated-checkout web component so it reflects the current cart.
function syncWalletButtons(itemCount) {
  const hasItems = itemCount > 0;
  // Logo also lives in the persistent shell (after the wallet block) so the
  // bottom order is checkout → apple pay → logo; toggle it with the cart count.
  const logo = document.querySelector('[data-cart-drawer] [data-cart-logo]');
  if (logo) logo.hidden = !hasItems;

  const wallet = document.querySelector('[data-cart-drawer] [data-cart-dynamic]');
  if (!wallet) return;
  if (hasItems) {
    wallet.hidden = false;
    // The component reads the live cart; re-init makes it re-render after an
    // empty→items transition. Guarded — only present once Shopify's button JS
    // has loaded.
    try {
      if (window.Shopify && Shopify.PaymentButton && typeof Shopify.PaymentButton.init === 'function') {
        Shopify.PaymentButton.init();
      }
    } catch (_) {}
  } else {
    wallet.hidden = true;
  }
}

function formatMoney(cents) {
  const symbol = (window.Shopify && Shopify.currency && Shopify.currency.active) || '';
  const amount = (cents / 100).toFixed(2);
  return `€${amount}`;
}

// LINE ITEM ACTIONS in drawer
document.addEventListener('click', async (e) => {
  const up = e.target.closest('[data-qty-up]');
  const down = e.target.closest('[data-qty-down]');
  const rm = e.target.closest('[data-remove]');
  if (!up && !down && !rm) return;
  e.preventDefault();
  const line = parseInt((up && up.dataset.qtyUp) || (down && down.dataset.qtyDown) || (rm && rm.dataset.remove));

  let newQty = 0; // removal needs no current value
  if (up || down) {
    // Only +/- needs the current quantity — read it once.
    const cart = await (await fetch('/cart.js')).json();
    const item = cart.items[line - 1];
    if (!item) return;
    newQty = item.quantity + (up ? 1 : -1);
  }

  const res = await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ line, quantity: newQty })
  });
  // refreshCart always refetches /cart.js + the section render so the dynamic
  // checkout buttons (Apple Pay etc.) stay in sync — no need to pass the
  // change.js response in.
  refreshCart();
});

// AJAX ADD-TO-CART
document.addEventListener('submit', async (e) => {
  const form = e.target;
  if (!form.matches('form[data-product-form]')) return;
  e.preventDefault();
  const button = form.querySelector('button[type="submit"]');
  const labels = button.querySelectorAll('span');
  const originalText = labels[0]?.textContent;
  if (labels[0]) labels[0].textContent = 'adding…';
  button.disabled = true;
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'Accept': 'application/json' }
    });
    if (!res.ok) throw new Error('Add failed');
    if (labels[0]) labels[0].textContent = 'added ✓';
    await refreshCart();
    openDrawer(drawer);
    setTimeout(() => { if (labels[0]) labels[0].textContent = originalText; button.disabled = false; }, 1200);
  } catch (err) {
    if (labels[0]) labels[0].textContent = 'try again';
    setTimeout(() => { if (labels[0]) labels[0].textContent = originalText; button.disabled = false; }, 1500);
  }
});

// SIZE / VARIANT SELECTION
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.size-btn');
  if (!btn) return;
  const form = btn.closest('form');
  if (!form) return;
  const position = btn.dataset.optionPosition;
  // Toggle pressed state within the same option position
  form.querySelectorAll(`.size-btn[data-option-position="${position}"]`).forEach(b => b.removeAttribute('aria-pressed'));
  btn.setAttribute('aria-pressed', 'true');
  // Update label
  const lbl = form.querySelector(`[data-option-value="${position}"]`);
  if (lbl) lbl.textContent = `[ ${btn.dataset.optionValueText} ]`;
  // Update hidden id input
  const idInput = form.querySelector('input[name="id"]');
  if (idInput && btn.dataset.variantId) idInput.value = btn.dataset.variantId;
  // Toggle Add vs Notify CTAs
  const addBtn = form.querySelector('[data-cta-add]');
  const notifyBtn = form.querySelector('[data-cta-notify]');
  const payBtn = form.querySelector('[data-cta-pay]');
  const status = form.querySelector('[data-stock-status]');
  const available = btn.dataset.available === 'true';
  if (addBtn) addBtn.hidden = !available;
  // Hide express checkout for out-of-stock variants (can't buy them).
  if (payBtn) payBtn.hidden = !available;
  if (notifyBtn) {
    notifyBtn.hidden = available;
    notifyBtn.dataset.variantTitle = btn.dataset.optionValueText || '';
  }
  if (status) {
    const inLabel = status.dataset.labelIn || 'ready to ship';
    const outLabel = status.dataset.labelOut || 'out of stock';
    status.textContent = available ? inLabel : outLabel;
    status.classList.toggle('is-out', !available);
  }

  // Update price for the selected variant
  if (btn.dataset.variantId && window.__productData) {
    const variant = window.__productData.variants.find(v => String(v.id) === String(btn.dataset.variantId));
    if (variant) {
      const price = `€${(variant.price / 100).toFixed(2)}`;
      const ctaPrice = form.querySelector('[data-cta-price]');
      if (ctaPrice) ctaPrice.textContent = price;
    }
  }
});

// NOTIFY ME MODAL
const notifyModal = document.querySelector('[data-notify-modal]');

function openNotify(productTitle, variantTitle) {
  if (!notifyModal) return;
  // Build tags so each back-in-stock signup is easy to filter in admin → Customers.
  function slugify(s) {
    return (s || 'unknown')
      .toString()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60);
  }
  const productSlug = slugify(productTitle);
  const variantSlug = slugify(variantTitle || 'default');
  const tagsInput = notifyModal.querySelector('[data-notify-tags]');
  const firstNameInput = notifyModal.querySelector('[data-notify-firstname]');
  if (tagsInput) {
    tagsInput.value = `back-in-stock, bis-${productSlug}, bis-variant-${variantSlug}`;
  }
  // Stash the product/variant label in first_name so it's visible at a glance in the admin customer list.
  if (firstNameInput) {
    firstNameInput.value = `BIS: ${productTitle || 'unknown'}${variantTitle ? ' / ' + variantTitle : ''}`.slice(0, 100);
  }
  notifyModal.classList.add('is-open');
  notifyModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
  setTimeout(() => notifyModal.querySelector('[data-notify-email]')?.focus(), 50);
}

function closeNotify() {
  if (!notifyModal) return;
  notifyModal.classList.remove('is-open');
  notifyModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-cta-notify]');
  if (trigger) {
    openNotify(trigger.dataset.productTitle, trigger.dataset.variantTitle);
    return;
  }
  if (e.target.closest('[data-notify-close]')) { closeNotify(); return; }
  if (notifyModal && notifyModal.classList.contains('is-open') && e.target === notifyModal) {
    closeNotify();
  }
});

// (Escape handler consolidated above)

// SIZING MODAL
const sizingModal = document.querySelector('[data-sizing-modal]');
function openSizing() {
  if (!sizingModal) return;
  sizingModal.classList.add('is-open');
  sizingModal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}
function closeSizing() {
  if (!sizingModal) return;
  sizingModal.classList.remove('is-open');
  sizingModal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}
document.addEventListener('click', (e) => {
  if (e.target.closest('[data-sizing-open]')) { openSizing(); return; }
  if (e.target.closest('[data-sizing-close]')) { closeSizing(); return; }
  if (sizingModal && sizingModal.classList.contains('is-open') && e.target === sizingModal) closeSizing();
});

// POLICIES TABS
document.addEventListener('click', (e) => {
  const tab = e.target.closest('.policies__tab');
  if (!tab) return;
  const wrap = tab.closest('[data-policies]');
  if (!wrap) return;
  const target = tab.dataset.tab;
  wrap.querySelectorAll('.policies__tab').forEach(t => {
    t.classList.toggle('is-active', t === tab);
    t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
  });
  wrap.querySelectorAll('.policies__panel').forEach(p => {
    const match = p.dataset.panel === target;
    p.hidden = !match;
    p.classList.toggle('is-active', match);
  });
});

// EXPANDABLE PRODUCT DESCRIPTION
// Smoothly open/close the rest of the description by animating its measured
// height (no overshoot) plus a gentle fade. Honours prefers-reduced-motion.
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

// Cancel any in-flight desc animation cleanly so rapid toggles don't fight.
function clearDescAnim(el) {
  if (el._descDone) { el.removeEventListener('transitionend', el._descDone); el._descDone = null; }
}

function openDesc(el, panel) {
  clearDescAnim(el);
  el.hidden = false;
  // Raise the panel cap up-front so it can grow with the content.
  if (panel) panel.classList.add('info-panel--desc-open');
  if (reduceMotion.matches) { el.style.cssText = ''; return; }
  el.style.overflow = 'hidden';
  el.style.opacity = '0';
  el.style.maxHeight = '0px';
  el.style.transition = 'none';
  // force reflow so the 0px start is committed before we transition to target
  void el.offsetHeight;
  const target = el.scrollHeight;
  el.style.transition = 'max-height 0.4s cubic-bezier(0.22, 1, 0.36, 1), opacity 0.32s ease';
  el.style.maxHeight = target + 'px';
  el.style.opacity = '1';
  el._descDone = function (ev) {
    if (ev.propertyName !== 'max-height') return;
    clearDescAnim(el);
    // Release the fixed height so the panel can reflow naturally afterwards.
    el.style.maxHeight = 'none';
    el.style.overflow = '';
    el.style.transition = '';
  };
  el.addEventListener('transitionend', el._descDone);
}

function closeDesc(el, panel) {
  clearDescAnim(el);
  if (reduceMotion.matches) {
    el.hidden = true; el.style.cssText = '';
    if (panel) panel.classList.remove('info-panel--desc-open');
    return;
  }
  el.style.overflow = 'hidden';
  el.style.maxHeight = el.scrollHeight + 'px';
  el.style.transition = 'none';
  void el.offsetHeight;
  el.style.transition = 'max-height 0.34s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.26s ease';
  el.style.maxHeight = '0px';
  el.style.opacity = '0';
  el._descDone = function (ev) {
    if (ev.propertyName !== 'max-height') return;
    clearDescAnim(el);
    el.hidden = true;
    el.style.cssText = '';
    // Only now drop the panel cap back to its collapsed value — the panel has
    // already shrunk with the content, so this no longer causes a jump.
    if (panel) panel.classList.remove('info-panel--desc-open');
  };
  el.addEventListener('transitionend', el._descDone);
}

// First paragraph is always visible; toggle reveals/hides the rest below it.
document.addEventListener('click', (e) => {
  const toggle = e.target.closest('[data-desc-toggle]');
  if (!toggle) return;
  const wrap = toggle.closest('[data-desc]');
  if (!wrap) return;
  const restEl = wrap.querySelector('[data-desc-rest]');
  if (!restEl) return;
  const panel = toggle.closest('.info-panel');
  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  if (expanded) { closeDesc(restEl, panel); } else { openDesc(restEl, panel); }
  toggle.textContent = expanded ? '[ + ]' : '[ − ]';
  toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
});

// Show success state after the customer form posts.
// Shopify redirects back with either #contact_posted=true (contact form) or
// #customer_posted=true (customer form). Handle both for backward compatibility.
if (window.location.hash.includes('contact_posted=true') ||
    window.location.hash.includes('customer_posted=true') ||
    window.location.search.includes('customer_posted=true')) {
  const success = document.querySelector('[data-notify-success]');
  const form = document.querySelector('[data-notify-form]');
  if (success && form) {
    success.hidden = false;
    form.style.display = 'none';
    openNotify('', '');
  }
}

// Tiny debounce helper used by all resize/layout callbacks below.
function debounce(fn, ms) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
  };
}

// MEASURE the fixed-bottom UI (CTA pill + the full, locked info panel) and set
// --mobile-panel-h so the product image fills exactly the space above them.
// Mobile-only — desktop layout doesn't read these vars.
const mobileMQ = window.matchMedia('(max-width: 749px)');
function syncMobilePanelHeight() {
  if (!mobileMQ.matches) return;
  const panel = document.querySelector('.info-panel');
  if (!panel) return;
  const rect = panel.getBoundingClientRect();
  // Size the image area to END a few px ABOVE the panel's ACTUAL top edge, so the
  // dot selectors (which sit at the bottom of the image area) are never tucked
  // under the panel — even in the Instagram in-app browser where 100dvh and
  // safe-area insets are reported oddly. Measuring the real panel top instead of
  // trusting dvh makes this webview-proof.
  const clearance = 6;
  const carouselH = Math.max(140, Math.floor(rect.top) - clearance);
  document.documentElement.style.setProperty('--carousel-h', `${carouselH}px`);
  // Keep --mobile-panel-h in sync (used by fallback / other consumers).
  document.documentElement.style.setProperty('--mobile-panel-h', `${Math.ceil(window.innerHeight - rect.top) + clearance}px`);
}
if (document.querySelector('.info-stack')) {
  const debouncedSyncPanel = debounce(syncMobilePanelHeight, 120);
  syncMobilePanelHeight();
  window.addEventListener('resize', debouncedSyncPanel, { passive: true });
  mobileMQ.addEventListener('change', syncMobilePanelHeight);
  // The apple pay button hydrates asynchronously and toggles with stock, both of
  // which change the group's height after first paint — re-measure on any resize
  // of the group so the panel offset always matches.
  const ctaGroupEl = document.querySelector('.cta-group');
  if (ctaGroupEl && 'ResizeObserver' in window) {
    new ResizeObserver(debouncedSyncPanel).observe(ctaGroupEl);
  }
  // NOTE: we deliberately do NOT re-measure when the panel grows (e.g. tapping
  // [ + ] to expand the description). The image stays at its collapsed-state size
  // and the expanded panel simply overlays on top of it (it's fixed-position with
  // a higher z-index), instead of shrinking the product photo.
}

// BOTTOM SHEET — swipe up anywhere on the product page to pull the info panel up,
// swipe down to push it back. Bound to <main> so a swipe over the product image
// area (not just the panel) also lifts the sheet.
function setupBottomSheet() {
  const sheet = document.querySelector('.info-panel[data-sheet]');
  if (!sheet) return;
  const surface = document.querySelector('main') || document.body;

  const mq = window.matchMedia('(max-width: 749px)');
  const DRAG_THRESHOLD = 8;
  let startY = 0, startX = 0, lastY = 0;
  let startTime = 0;
  let mayDrag = false, dragging = false, expanded = false;
  let collapsedTranslate = 0;

  function getPeek() {
    return parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sheet-peek-h')) || 110;
  }

  function computeCollapsedTranslate() {
    return Math.max(0, sheet.offsetHeight - getPeek());
  }

  function snap(toExpanded) {
    expanded = toExpanded;
    sheet.classList.remove('is-dragging');
    sheet.style.transform = '';
    sheet.classList.toggle('is-expanded', expanded);
  }

  function shouldIgnore(target) {
    // Don't hijack swipes that start inside the CTA pill, cart drawer, or modals
    return !!target.closest('.cta-pill, [data-cart-drawer], [data-menu-drawer], .notify-modal, .sizing-modal, .cart-backdrop');
  }

  surface.addEventListener('pointerdown', (e) => {
    if (!mq.matches) return;
    if (shouldIgnore(e.target)) return;
    mayDrag = true;
    dragging = false;
    startY = e.clientY;
    startX = e.clientX;
    lastY = e.clientY;
    startTime = Date.now();
    collapsedTranslate = computeCollapsedTranslate();
  });

  surface.addEventListener('pointermove', (e) => {
    if (!mayDrag) return;
    const dy = e.clientY - startY;
    const dx = e.clientX - startX;

    if (!dragging) {
      if (Math.abs(dy) < DRAG_THRESHOLD) return;
      if (Math.abs(dx) > Math.abs(dy)) { mayDrag = false; return; }
      // Only start a drag in the direction that makes sense for the current state.
      // Collapsed → only an UPWARD swipe should start expansion (so taps + downward
      // swipes on product images still feel natural). Expanded → either direction.
      if (!expanded && dy > 0) { mayDrag = false; return; }
      dragging = true;
      sheet.classList.add('is-dragging');
      try { surface.setPointerCapture(e.pointerId); } catch (_) {}
    }

    if (e.cancelable) e.preventDefault();
    const base = expanded ? 0 : collapsedTranslate;
    const next = Math.max(0, Math.min(collapsedTranslate, base + dy));
    sheet.style.transform = `translateY(${next}px)`;
    lastY = e.clientY;
  }, { passive: false });

  function endDrag(e) {
    if (!mayDrag) return;
    mayDrag = false;
    if (!dragging) return;
    dragging = false;
    const dy = lastY - startY;
    const dt = Date.now() - startTime;
    const base = expanded ? 0 : collapsedTranslate;
    const finalPos = Math.max(0, Math.min(collapsedTranslate, base + dy));
    const isFling = dt < 250 && Math.abs(dy) > 24;
    let toExpanded;
    if (isFling) toExpanded = dy < 0;
    else toExpanded = finalPos < collapsedTranslate / 2;
    snap(toExpanded);
  }

  surface.addEventListener('pointerup', endDrag);
  surface.addEventListener('pointercancel', endDrag);

  mq.addEventListener('change', () => {
    expanded = false;
    sheet.classList.remove('is-expanded', 'is-dragging');
    sheet.style.transform = '';
  });
}
setupBottomSheet();


// ACCELERATED CHECKOUT — on mobile, show exactly ONE wallet button matched to the
// platform: Apple Pay on iOS (when the device supports it), Shop Pay otherwise.
// Shopify's <shopify-accelerated-checkout-cart> renders one button per entry in
// its `wallet-configs` JSON attribute (light DOM). So we filter that array down to
// a single preferred-and-available wallet → the component renders a single button.
// Shop Pay is always available, so it's the safe fallback that never renders empty.
function setupSingleWallet() {
  const mq = window.matchMedia('(max-width: 749px)');

  function preferred() {
    const ua = navigator.userAgent || '';
    const isiOS = /iP(hone|ad|od)/.test(ua) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    // Apple Pay only when the device/browser actually supports it.
    let applePayOK = false;
    try {
      applePayOK = !!(window.ApplePaySession && ApplePaySession.canMakePayments && ApplePaySession.canMakePayments());
    } catch (_) {}
    if (isiOS && applePayOK) return 'apple_pay';
    return 'shop_pay'; // universally available — never renders empty
  }

  // Reduce wallet-configs to a single entry (the preferred wallet, else shop_pay,
  // else the first). Idempotent: no write once it's already the single right one.
  function filterConfigs(el) {
    const raw = el.getAttribute('wallet-configs');
    if (!raw) return;
    let arr;
    try { arr = JSON.parse(raw); } catch (_) { return; }
    if (!Array.isArray(arr) || !arr.length) return;
    const want = preferred();
    let chosen = arr.filter(w => w && w.name === want);
    if (!chosen.length) chosen = arr.filter(w => w && w.name === 'shop_pay');
    if (!chosen.length) chosen = [arr[0]];
    const next = JSON.stringify(chosen);
    if (next !== raw) el.setAttribute('wallet-configs', next);
  }

  function apply() {
    if (!mq.matches) return; // desktop keeps all wallets
    // Re-query on every apply — the cart drawer (and its dynamic-checkout block)
    // gets (re)inserted by refreshCart, so we can't cache a container list at
    // page load. On an empty-cart first visit the block doesn't exist yet at
    // all; before this fix the function bailed and never reattached after the
    // first add-to-cart, leaving wallet-configs unfiltered → Apple Pay never
    // selected.
    document.querySelectorAll(
      '.cart-drawer__dynamic[data-cart-dynamic] shopify-accelerated-checkout-cart, ' +
      '.cart-drawer__dynamic[data-cart-dynamic] shopify-accelerated-checkout'
    ).forEach(filterConfigs);
  }

  // Watch the whole document — covers the drawer being refreshed AND the
  // wallet web component hydrating its internal DOM with the wallet-configs
  // attribute. Cheap because filterConfigs is a no-op once the right value
  // is already on the attribute.
  new MutationObserver(() => apply()).observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['wallet-configs']
  });

  apply();
  // Catch the component if it hydrates slightly after first paint.
  setTimeout(apply, 150);
  setTimeout(apply, 600);
  setTimeout(apply, 1600);
}
setupSingleWallet();


// SCROLL "ACTIVE" SLIDE TRACKING (product images) + thumb pill sync + click-to-navigate
// Skip entirely on mobile where this element is display:none — saves listeners + rect work.
const productScroller = document.querySelector('.product-scroll');
if (productScroller && productScroller.offsetParent !== null) {
  const slides = Array.from(productScroller.querySelectorAll('.product-scroll__slide'));
  const thumbButtons = document.querySelectorAll('.thumb-pill__btn');
  if (slides.length) slides[0].classList.add('is-active');

  function markActiveByIndex(imgIndex) {
    slides.forEach(s => {
      const idx = parseInt(s.dataset.imgIndex, 10);
      s.classList.toggle('is-active', idx === imgIndex);
    });
    thumbButtons.forEach(b => {
      b.classList.toggle('is-current', parseInt(b.dataset.thumbTarget, 10) === imgIndex);
    });
  }

  // Active = whichever slide's center is closest to the scroller's center.
  // This works regardless of slide height vs viewport (the old IntersectionObserver
  // with threshold 0.6 silently failed when slides were shorter than 60% of viewport).
  let activeImgIndex = -1;
  function updateActiveByCenter() {
    if (!slides.length) return;
    const scrollerCenter = productScroller.scrollTop + productScroller.clientHeight / 2;
    let nearest = null;
    let nearestDiff = Infinity;
    for (const s of slides) {
      const c = s.offsetTop + s.offsetHeight / 2;
      const d = Math.abs(c - scrollerCenter);
      if (d < nearestDiff) { nearestDiff = d; nearest = s; }
    }
    if (!nearest) return;
    const idx = parseInt(nearest.dataset.imgIndex, 10);
    if (!isNaN(idx) && idx !== activeImgIndex) {
      activeImgIndex = idx;
      markActiveByIndex(idx);
    }
  }

  let centerTicking = false;
  productScroller.addEventListener('scroll', () => {
    if (centerTicking) return;
    centerTicking = true;
    requestAnimationFrame(() => { updateActiveByCenter(); centerTicking = false; });
  }, { passive: true });
  requestAnimationFrame(updateActiveByCenter);

  // Click on a non-active slide → smooth scroll by ±1 depending on direction relative to current active slide
  productScroller.addEventListener('click', (e) => {
    const slide = e.target.closest('.product-scroll__slide');
    if (!slide || slide.classList.contains('is-active')) return;
    const slideTop = slide.getBoundingClientRect().top;
    const scrollerTop = productScroller.getBoundingClientRect().top;
    const slideMidVsCenter = slideTop + slide.offsetHeight / 2 - scrollerTop - productScroller.clientHeight / 2;
    const direction = slideMidVsCenter < 0 ? -1 : 1;
    smoothScrollByDirection(productScroller, direction);
  });

  // Click on a thumb-pill button → smooth scroll to that image (stay in middle copy)
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.thumb-pill__btn');
    if (!btn) return;
    const target = parseInt(btn.dataset.thumbTarget, 10);
    const setSize = parseInt(productScroller.dataset.setSize, 10) || 1;
    // Always target the matching slide in the middle copy — use offsetTop so the
    // flex `gap` between slides is included in the position.
    const targetSlide = slides[setSize + target];
    if (!targetSlide) return;
    const targetTop = targetSlide.offsetTop;

    productScroller.__loop && (productScroller.__loop.suppress = true);
    productScroller.scrollTo({ top: targetTop, behavior: 'smooth' });
    setTimeout(() => {
      if (productScroller.__loop) productScroller.__loop.suppress = false;
    }, 700);
  });
}

// INFINITE LOOP — for any element with [data-loop-scroller]
// Markup contains 3 copies of the items; we keep the user inside the middle copy
// and silently jump them back when they reach the boundaries.
function setupInfiniteLoop(scroller) {
  // Skip hidden scrollers (e.g., desktop product-scroll on mobile) — no point
  // measuring rects or attaching listeners to display:none elements.
  if (scroller.offsetParent === null) return;
  let track = scroller;
  const mobileTrack = scroller.querySelector('.sky__mobile');
  if (mobileTrack && getComputedStyle(mobileTrack).display !== 'none') {
    track = mobileTrack;
  }

  const setSize = parseInt(scroller.dataset.setSize, 10);
  if (!setSize || setSize < 1) return;

  const allItems = Array.from(track.children).filter(el => {
    const cs = getComputedStyle(el);
    return cs.scrollSnapAlign && cs.scrollSnapAlign !== 'none';
  });
  if (allItems.length < setSize * 2) return;

  // Measure set height from actual element positions so it includes any flex `gap`
  let itemHeight = allItems[0].getBoundingClientRect().height;
  let setHeight = (allItems[setSize] ? allItems[setSize].offsetTop : itemHeight * setSize) - allItems[0].offsetTop;

  // Start centered in the middle copy
  requestAnimationFrame(() => { track.scrollTop = setHeight; });

  // Expose API for programmatic scrolling that pauses loop-jumping
  track.__loop = {
    setHeight: () => setHeight,
    setSize,
    suppress: false
  };

  // Rebase the user into the middle copy only AFTER scrolling has settled.
  // Doing it mid-scroll while scroll-snap is engaged is the main cause of glitchy
  // jumps and stutters. We wait ~180ms after the last scroll event, then jump
  // silently by the same delta that puts the user on the same image in the middle copy.
  let settleTimer = null;
  function rebaseIfNeeded() {
    if (track.__loop.suppress) return;
    const y = track.scrollTop;
    // Find nearest snap-eligible slide
    let nearestIdx = -1;
    let nearestDiff = Infinity;
    for (let i = 0; i < allItems.length; i++) {
      const d = Math.abs(allItems[i].offsetTop - y);
      if (d < nearestDiff) { nearestDiff = d; nearestIdx = i; }
    }
    if (nearestIdx < 0) return;
    let targetIdx = -1;
    if (nearestIdx >= setSize * 2) targetIdx = nearestIdx - setSize;       // 3rd copy → middle
    else if (nearestIdx < setSize) targetIdx = nearestIdx + setSize;       // 1st copy → middle
    if (targetIdx < 0) return;
    const delta = allItems[targetIdx].offsetTop - allItems[nearestIdx].offsetTop;
    const prevBehavior = track.style.scrollBehavior;
    track.style.scrollBehavior = 'auto';
    track.scrollTop = y + delta;
    track.style.scrollBehavior = prevBehavior;
  }

  track.addEventListener('scroll', () => {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(rebaseIfNeeded, 180);
  }, { passive: true });

  window.addEventListener('resize', debounce(() => {
    requestAnimationFrame(() => {
      itemHeight = allItems[0].getBoundingClientRect().height;
      setHeight = (allItems[setSize] ? allItems[setSize].offsetTop : itemHeight * setSize) - allItems[0].offsetTop;
      track.scrollTop = setHeight;
    });
  }, 150));
}

document.querySelectorAll('[data-loop-scroller]').forEach(setupInfiniteLoop);

// Helper: smoothly scroll one slide up or down in a loop scroller while keeping the user inside the middle copy.
// Avoids glitches by temporarily suppressing the loop-jump check and rebasing into the middle copy on completion.
function smoothScrollByDirection(track, direction /* -1 up, +1 down */) {
  if (!track.__loop) return;
  const children = Array.from(track.children).filter(el => {
    const cs = getComputedStyle(el);
    return cs.scrollSnapAlign && cs.scrollSnapAlign !== 'none';
  });
  if (!children.length) return;

  track.__loop.suppress = true;
  // Find the slide whose offsetTop is closest to the current scroll position, then step from there
  const y = track.scrollTop;
  let nearestIdx = 0;
  let nearestDiff = Infinity;
  children.forEach((el, i) => {
    const d = Math.abs(el.offsetTop - y);
    if (d < nearestDiff) { nearestDiff = d; nearestIdx = i; }
  });
  const targetIdx = Math.max(0, Math.min(children.length - 1, nearestIdx + direction));
  const targetTop = children[targetIdx].offsetTop;

  track.scrollTo({ top: targetTop, behavior: 'smooth' });

  // After the smooth scroll, rebase scroll into the middle copy if we drifted out
  setTimeout(() => {
    track.__loop.suppress = false;
    const setHeight = track.__loop.setHeight();
    const y = track.scrollTop;
    if (y >= setHeight * 2 || y < setHeight) {
      // Rebase silently
      const offsetWithinSet = ((y % setHeight) + setHeight) % setHeight;
      const prevBehavior = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollTop = setHeight + offsetWithinSet;
      track.style.scrollBehavior = prevBehavior;
    }
  }, 600);
}

// ── Product carousel: horizontal swipe + infinite loop + dot sync ────
function initProductCarousel() {
  const carousel = document.querySelector('[data-product-carousel]');
  const dotsWrap = document.querySelector('[data-product-dots]');
  if (!carousel) return;

  const dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.product-dot')) : [];
  const setSize = parseInt(carousel.dataset.setSize, 10) || dots.length || 1;
  const slides = Array.from(carousel.querySelectorAll('.product-carousel__slide'));
  // Loop only when we have 3× copies in the DOM (setSize ≥ 2 and at least 3 sets).
  const canLoop = slides.length >= setSize * 3 && setSize >= 2;

  function setActiveDot(index) {
    dots.forEach((d, i) => d.classList.toggle('is-active', i === index));
  }

  function snapToMiddleCopy() {
    // Place the user on the first slide of the middle copy without animation.
    const w = carousel.offsetWidth;
    const prev = carousel.style.scrollBehavior;
    carousel.style.scrollBehavior = 'auto';
    carousel.scrollLeft = w * setSize;
    carousel.style.scrollBehavior = prev;
  }

  if (canLoop) {
    requestAnimationFrame(snapToMiddleCopy);
  }

  let suppress = false;
  let lastJump = 0;
  let ticking = false;

  carousel.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      const w = carousel.offsetWidth;
      const x = carousel.scrollLeft;
      const slideIdx = Math.round(x / w);

      // Dot index = which image are we currently on (mod set size)
      const imgIdx = canLoop ? (((slideIdx % setSize) + setSize) % setSize) : slideIdx;
      setActiveDot(imgIdx);

      // Infinite loop: silently rebase to middle copy when we drift to the edges
      if (canLoop && !suppress) {
        const setWidth = w * setSize;
        const now = performance.now();
        if (now - lastJump > 250) {
          if (x >= setWidth * 2) {
            const prev = carousel.style.scrollBehavior;
            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = x - setWidth;
            carousel.style.scrollBehavior = prev;
            lastJump = now;
          } else if (x < setWidth) {
            const prev = carousel.style.scrollBehavior;
            carousel.style.scrollBehavior = 'auto';
            carousel.scrollLeft = x + setWidth;
            carousel.style.scrollBehavior = prev;
            lastJump = now;
          }
        }
      }
      ticking = false;
    });
  }, { passive: true });

  // Click dot → jump to that image in the middle copy
  dots.forEach(dot => {
    dot.addEventListener('click', () => {
      const index = parseInt(dot.dataset.dotIndex, 10);
      const targetSlideIdx = canLoop ? (setSize + index) : index;
      suppress = true;
      carousel.scrollTo({ left: targetSlideIdx * carousel.offsetWidth, behavior: 'smooth' });
      setTimeout(() => { suppress = false; }, 700);
    });
  });

  // Keep the user re-centered on the middle copy after resize / rotation (debounced)
  window.addEventListener('resize', debounce(() => {
    if (canLoop) requestAnimationFrame(snapToMiddleCopy);
  }, 150));
}

document.addEventListener('DOMContentLoaded', initProductCarousel);
